import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const passwordActions = createActionGroup({
  source: 'Password',
  events: {
    recover_password_page_open: emptyProps(),
    recover_password_request_start: props<{ email: string }>(),
    recover_password_request_success: emptyProps(),
    recover_password_request_failure: emptyProps(),
    reset_password_request_start: props<{ password: string; email: string; token: string }>(),
    reset_password_request_success: emptyProps(),
    reset_password_request_failure: emptyProps()
  }
});
